var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOfficeClose = function SvgOfficeClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.556,
    height: 16.555,
    viewBox: "0 0 16.556 16.555",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office_close",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "office_close",
    d: "M16.05,16.554a.5.5,0,0,1-.278-.084L.076.775A.5.5,0,0,1,.14.145a.5.5,0,0,1,.707,0l.581.58A1,1,0,0,1,2.079.483H9.595l-1.5,1.5H3.579a1,1,0,0,0-.652.242L6.367,5.665a.5.5,0,0,0,.066.081L9.968,9.281a.508.508,0,0,0,.079.065l3.532,3.532V7.813l1.5-1.5v8.065L16.4,15.7a.5.5,0,0,1-.354.852Zm-1.971-.07h-12a1,1,0,0,1-1-1V3.191l1.5,1.5v9.292a1,1,0,0,0,1,1h9a1,1,0,0,0,.259-.034l1.5,1.5A1,1,0,0,1,14.079,16.484ZM9.592,7.49h0L7.908,5.806l3.671-3.671,1.685,1.685L9.593,7.49ZM13.9,3.184h0L12.215,1.5,13.231.483l1.685,1.685L13.9,3.183Z",
    transform: "translate(0.006 0.002)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office_close.eb551bf5.svg";
export { ForwardRef as ReactComponent };